import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { NavLink } from "react-router-dom";

const hpMainSlider = {
    dots: false,
    autoplay: true,
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };


const Home_improvement1 = () => {
    return (
        <>
        <div id="maincarousel">
        <div className="container">
          <div className="row">
                              <div className="col-lg-3">
                              <div class="sc-gWXbKe hoZTIr __pf" id="__pf">
                              <div data-pf-type="Block" className="sc-bilyIR cCHonK pf-16_">
                    <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-17_">
                      <i className="sc-gIDmLj huzWMp pf-18_ pfa pfa-bars" data-pf-type="Icon" />
                     
                        <NavLink 
                            to={'/home-improvement'}
                            exact
                            style={{color:'#fff'}}
                          >
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-19_">
                        Home Improvement
                        </span>
                        </NavLink>
                    </h3>
                    <div className="sc-bilyIR cCHonK pf-20_">
                    <NavLink 
                            to={'/cleaning-supplies'}
                            exact
                          >
                    
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-21_">
                        <img
                          src="	https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659604553898xrMVpG.png"
                          srcSet="	https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659604553898xrMVpG.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-22_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-24_">
                        Cleaning Supplies
                        </span>
                      </h3>
                      </NavLink>
                      </div>
                    <div className="sc-bilyIR cCHonK pf-25_"
                    >
                      <NavLink 
                            to={'/electrical'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-26_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/16596051090102zKeo8.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/16596051090102zKeo8.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-27_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-29_">
                        Electrical
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                    
                    <div
                      
                      className="sc-bilyIR cCHonK pf-30_"
                    >
                      <NavLink 
                            to={'/hardware'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-31_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659605172676Y9txOr.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659605172676Y9txOr.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-32_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-34_">
                        Hardware
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                    <div
                      
                      className="sc-bilyIR cCHonK pf-35_"
                    >
                      <NavLink 
                            to={'/kitchen-bath-fixtures'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-36_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659605228641fyl7TZ.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659605228641fyl7TZ.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-37_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-39_">
                        Kitchen & Bath Fixtures
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                    <div
                      
                      className="sc-bilyIR cCHonK pf-40_"
                    >
                      <NavLink 
                            to={'/painting-supplies-tools-wall-treatments'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-41_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659605290829K4itCM.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659605290829K4itCM.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-42_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-44_">
                        Painting Tools,Wall Treatments
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                    <div
                      
                      className="sc-bilyIR cCHonK pf-45_"
                    >
                      <NavLink 
                            to={'/power-hand-tools'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-46_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659605341955dboKwQ.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659605341955dboKwQ.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-47_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-49_">
                        Power & Hand Tools
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                  </div>
                  </div>
                              </div>
            <div className="col-lg-9"> <Slider {...hpMainSlider}>
            <div className="item">
                <a href="/home-improvement" className="banner"><img src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/61/1659074813982KIpW5D.png" style={{width: '100%'}} className='image_banner' alt="首页面（新）" /></a>
            </div>
            <div className="item">
                <a href="/power-hand-tools" className="banner"><img src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/61/165907481396094K4OG.png" style={{width: '100%' }} className='image_banner' alt="Modern L-Shaped Sofa Price" /></a>
            </div>
            {/* <div className="item">
                <a href="/products/sofa" className="banner"><img src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/61/1657711628171PZ80nC.png" style={{width: '100%'}} alt="Sofa S1015" /></a>
            </div> */}
            
            
            
        </Slider></div>
          </div>
        </div>
        <div className='container' style={{marginTop:'30px'}}>
            <div className='row sc-gWXbKe hoZTIr __pf' id="__pf">
                <div className='col-lg-6'>
                <a href="/power-tools">
                <div data-pf-type="Column" className="sc-hAcGzb bAQARH pf-571_impr">
                <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-58_">
                <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-60_"><br />
                <span style={{'font-weight': 'bold'}}></span>
                <br />

                </span>
                </h3>
                </div> 
                </a>
                </div>
                <div className='col-lg-6 ' >
                <a href="/cleaning-supplies">
                <div data-pf-type="Column" className="sc-hAcGzb bAQARH pf-611_impr">
                    <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-62_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-64_">
                        
                        <br />
                        <span style={{ fontWeight: 700 }}></span>
                        <br />
                        </span>
                    </h3>
                    </div>
</a>
                </div>
            </div>
        </div>
       
        </div>
        </>

    )
}

export default Home_improvement1;
